import React, { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReviewPopup from "../ReviewPopup/ReviewPopup";
import { useSelector, useDispatch } from "react-redux";
import {
  updateRecordStatus,
  fetchFilteredRecords,
} from "../../Pages/RecordsHandlingPage/recordsHandlingSlice";
import { useNavigate } from "react-router";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { Box, Typography } from "@mui/material";
import "./RecordHandlingGrid.css";

const RecordHandlingGrid = () => {
  const dispatch = useDispatch();
  const { records, status, error } = useSelector(
    (state) => state.recordsHandling
  );
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isPopupOpen, setPopupOpen] = useState(false);

  console.log(records);

  const columns = [
    { field: "jobId", headerName: "Job ID", width: 90 },
    { field: "oneKeyId", headerName: "OneKey ID", width: 150 },
    { field: "ahpraId", headerName: "AHPRA ID", width: 150 },
    {
      field: "review",
      headerName: "Review",
      width: 90,
      renderCell: (params) =>
        params.row.approvalStatus === "Awaiting Approval" ? (
          <IconButton onClick={() => handleReviewClick(params.row)}>
            <VisibilityIcon sx={{ color: "#2E3B55" }} />
          </IconButton>
        ) : null,
    },
    { field: "recordFirstName", headerName: "First Name", width: 150 },
    { field: "recordLastName", headerName: "Last Name", width: 150 },
  
    
    { field: "validationStatus", headerName: "Validation Status", width: 180 },
    { field: "matchingStatus", headerName: "Matching Status", width: 180 },
    //{ field: "registrationStatus", headerName: "AHPRA Registration Status", width: 220 },
    
    {
      field: "expiryDate",
      headerName: "Registration Expiration Date",
      width: 230,
      renderCell: (params) =>
        params.value
          ? new Intl.DateTimeFormat("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).format(new Date(params.value))
          : "",
    },
    {
      field: "firstRegistrationDate",
      headerName: "AHPRA First Registration Date",
      width: 200,
      renderCell: (params) =>
        params.value
          ? new Intl.DateTimeFormat("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).format(new Date(params.value))
          : "",
    },
    

  
    // ✅ Source Data Fields
    { field: "sourceFirstName", headerName: "Source First Name", width: 160 },
    { field: "sourceLastName", headerName: "Source Last Name", width: 160 },
    { field: "sourceSpecialty", headerName: "Source Specialty", width: 200 },
    { field: "sourceState", headerName: "Source State", width: 120 },
    { field: "sourceCity", headerName: "Source City", width: 150 },
    { field: "sourcePostCode", headerName: "Source Post Code", width: 120 },
  
    // ✅ AHPRA Response Data Fields
    { field: "ahpraFirstName", headerName: "AHPRA First Name", width: 160 },
    { field: "ahpraLastName", headerName: "AHPRA Last Name", width: 160 },
    { field: "ahpraMiddleName", headerName: "AHPRA Middle Name", width: 160 },
    { field: "ahpraSpecialty", headerName: "AHPRA Specialty", width: 200 },
    { field: "ahpraSpecialty2", headerName: "AHPRA Specialty2", width: 200 },
    { field: "ahpraSpecialty3", headerName: "AHPRA Specialty3", width: 200 },
    { field: "ahpraState", headerName: "AHPRA State", width: 120 },
    { field: "ahpraCity", headerName: "AHPRA City", width: 150 },
    { field: "ahpraPostCode", headerName: "AHPRA Post Code", width: 120 },
    { field: "ahpraProfession", headerName: "AHPRA Profession", width: 200 },
    { field: "ahpraqualification", headerName: "AHPRA qualification", width: 300 },
    { field: "ahpraqualification2", headerName: "AHPRA qualification2", width: 300 },
    { field: "ahpraqualification3", headerName: "AHPRA qualification3", width: 300 },
  ];

  const handleReviewClick = (row) => {
    setSelectedRecord(row);
    setPopupOpen(true);
  };

  const handlePopupAction = (approvalStatus) => {
    dispatch(
      updateRecordStatus({
        queueId: selectedRecord.queueId,
        approvalStatus,
        userId: "current_user",
      })
    ).then(() => {
      dispatch(fetchFilteredRecords({}));
    });
    setPopupOpen(false);
    setSelectedRecord(null);
    if (approvalStatus === "Approved") {
      alert("Record Approved!");
    } else {
      alert("Record Rejected!");
    }
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setSelectedRecord(null);
  };

  useEffect(() => {
    if (status === "failed" && error === "No records found.") {
      alert("No records found!");
    }
  }, [status]);

  return (
    <>
      {status === "loading" ? (
        <Box
          className="spinner-container"
          sx={{ textAlign: "center", marginTop: "2rem" }}
        >
          <CircularProgress sx={{ color: "#2E3B55" }} />
          <Typography
            variant="body1"
            sx={{ marginTop: "1rem", color: "#2E3B55" }}
          >
            Loading Records...
          </Typography>
        </Box>
      ) : (
        <div className="record-data-grid-container">
          <DataGrid
            // rows={rows}
            rows={records}
            columns={columns}
            getRowId={(row) => `${row.queueId}`}
            loading={status === "loading"}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
            disableRowSelectionOnClick
            sx={{
              border: "2px solid #2e3b55",
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "#f5f5f5",
                color: "#2e3b55",
                fontSize: "16px",
                fontWeight: "bolder",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-root": {
                height: "100%",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "14px",
              },
              overflowX: "scroll",
            }}
            initialState={{
              density: "compact",
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
          />
        </div>
      )}

      {isPopupOpen && (
        <ReviewPopup
          selectedRecord={selectedRecord}
          onApprove={() => handlePopupAction("Approved")}
          onReject={() => handlePopupAction("Rejected")}
          onClose={handleClosePopup}
        />
      )}
    </>
  );
};

export default RecordHandlingGrid;
